import "core-js/modules/es.array.map";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import { serverList, announceChannelData } from "@/api/gmToolNew/gmToolNew";
import gmToolNew from "@/mixins/module/gmToolNew";
export default {
  mixins: [gmToolNew],
  props: {},
  data: function data() {
    return {
      serverListYJ: [],
      serverChannel: [],
      server_channel: "",
      show_test: "",
      serverType: [{
        label: this.$t('show'),
        value: 1
      }, {
        label: this.$t('notShow'),
        value: 0
      }],
      serverIdList: [],
      checked: false,
      customLevel: [{
        label: "自定义层级筛选",
        value: '1'
      }],
      levelItem: ''
    };
  },
  created: function created() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (_this.szgmItemList && !_this.szgmItemList.length) {
                _this.$store.dispatch('gmTool/init/getItemList');
              } // if (process.env.VUE_APP_COUNTTRY == "CN") {
              //   this.serverChannel = [{ label: "taptap", value: "taptap" }, { label: "wegame", value: "wegame" }]
              // } else if (process.env.VUE_APP_COUNTTRY == "VN") {
              //   this.serverChannel = [{ label: "vn", value: "vn" }]
              // }
              // this.$store.dispatch('gmToolYJ/init/getserverListYJ').then(res=>{
              //   this.serverListYJ = res
              //   this.paramsData.server_id =res[0] ? res[0].serverID : ''
              // })


              setTimeout(function () {
                _this.getannounceChannelData();
              }, 500);

            case 2:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  activated: function activated() {},
  computed: {},
  methods: {
    getannounceChannelData: function getannounceChannelData() {
      var _this2 = this;

      console.log("this.paramsData", this.paramsData);

      if (!this.paramsData.env_id) {
        return;
      }

      announceChannelData(this.paramsData).then(function (res) {
        if (res.status == 200) {
          res.data.map(function (i) {
            i.label = i.announce_channel_name;
            i.value = i.announce_channel_mark;
          });
          _this2.serverChannel = res.data || [];
        }
      });
    },
    envIdChange: function envIdChange() {
      this.serverChannel = [];
      this.server_channel = "";
      this.show_test = "";
      this.paramsData.server_id = "";
      this.serverID = [];
      this.serverListYJ = [];
      this.paramsData.channel = "";
      this.getannounceChannelData();
    },
    serverChange: function serverChange() {
      if (this.paramsData) {
        this.paramsData.server_id = '';
      }

      if (this.searchData) {
        this.searchData.server_id = '';
      }

      this.serverListYJ = [];
      this.show_test = "";
    },
    serverChannelChange: function serverChannelChange() {
      var ismessage = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

      if (this.paramsData) {
        this.paramsData.server_id = '';
      }

      if (this.searchData) {
        this.searchData.server_id = '';
      }

      this.serverListYJ = [];

      if (!this.server_channel) {
        ismessage && this.$message.error('请选择服务器渠道');
        return;
      }

      if (this.show_test === "") {
        // this.$message.error('请选择是否是测试服')
        return;
      }

      this.checked = false;
      this.getServerList();
      this.autoSelectAll = true;
      this.trySelectAll();
    },
    severChange: function severChange(val) {
      this.tableData = [];
      this.total = 0;

      if (this.paramsData) {
        this.paramsData.page = 1;
      }

      if (this.searchData) {
        this.searchData.page = 1;
      }

      if (val.length === this.serverListYJ.length) {
        this.checked = true;
      } else {
        this.checked = false;
      }
    },
    getServerList: function getServerList() {
      var _this3 = this;

      var env_id = this.propsData ? this.propsData.env_id : this.paramsData.env_id;
      serverList({
        server_channel: this.server_channel,
        show_test: this.show_test,
        env_id: env_id,
        game_id: this.rawData.game_id
      }).then(function (res) {
        if (res.code == 200) {
          _this3.serverListYJ = res.data;
        }
      });
    },
    envIdChangeN: function envIdChangeN() {
      this.serverChannel = [];
      this.server_channel = "";
      this.show_test = "";
      this.searchData.server_id = "";
      this.serverID = [];
      this.serverListYJ = [];
      this.getannounceChannelDataN();
    },
    getannounceChannelDataN: function getannounceChannelDataN() {
      var _this4 = this;

      if (!this.searchData.env_id) {
        return;
      }

      announceChannelData(this.searchData).then(function (res) {
        if (res.status == 200) {
          res.data.map(function (i) {
            i.label = i.announce_channel_name;
            i.value = i.announce_channel_mark;
          });
          _this4.serverChannel = res.data || [];
        }
      });
    },
    selectAll: function selectAll() {
      var _this5 = this;

      this.paramsData.server_id = [];

      if (this.checked) {
        this.serverListYJ.map(function (item) {
          _this5.paramsData.server_id.push(item.serverID);
        });
      } else {
        this.paramsData.server_id = [];
      }
    },
    royalSeverChange: function royalSeverChange(val) {
      console.log("val.length === this.serverLists.length", val);

      if (val.length === this.serverLists.length) {
        this.checked = true;
      } else {
        this.checked = false;
      }
    }
  }
};